export default __webpack_public_path__ + "static/media/BlueCanvas.5008601b.webp";